import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPancardReport,
  fetchAllPancardReport,
} from "../../../redux/reportPanCardSlice";
import PanCardReportPage from "./PanCardReportPage";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { logger } from "../../../utils/logger";

const PanCardFilters = () => {
  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const [fromdate, setFromdate] = useState(null);
  const [todate, setTodate] = useState(null);
  const [reportType, setReportType] = useState("");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const { user, role } = useSelector((state) => state.auth);

  const handleFilter = async () => {
    try {
      setIsFilterClicked(true);
      setLoading(true);
      setData([]);
      if (fromdate && todate) {
        const response = await dispatch(
          fetchPancardReport({ fromdate, todate })
        );
        const payload = response?.payload;
        if (Array.isArray(payload?.data) && payload.data.length > 0) {
          setData(payload.data);
          setReportType("FilteredPancardReport");
          logger.info("Filter applied successfully", {
            filterType: "PanCard - From/To Date",
            from: fromdate,
            to: todate,
            username: user?.username,
            role: role,
          });
        } else {
          setData([]);
          setReportType("");
          logger.warn("Filter applied but no data found", {
            filterType: "PanCard - From/To Date",
            from: fromdate,
            to: todate,
            username: user?.username,
            role: role,
          });
        }
      }
    } catch (error) {
      logger.error("Error Occur during Pancard Filter", { error: error });
      console.error("Error in handleFilter:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFetchall = async () => {
    try {
      setIsFilterClicked(true);
      setLoading(true);
      setData([]);
      const response = await dispatch(fetchAllPancardReport());
      const payload = response?.payload;
      if (Array.isArray(payload?.data) && payload.data.length > 0) {
        setData(payload.data);
        setReportType("OverallPancardReport");
        logger.info("Filter applied successfully", {
          filterType: "Overall Pancard Report",
          username: user?.username,
          role: role,
        });
      } else {
        setData([]);
        setReportType("");
        logger.warn("Filter applied but no data found", {
          filterType: "Overall Pancard Report",
          username: user?.username,
          role: role,
        });
      }
    } catch (error) {
      logger.error("Error Occur during Overall Pancard Filter", {
        error: error,
      });
      console.error("Error in handleFilter:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {}, [data]);

  return (
    <>
      <div>
        <Box 
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 2,
            marginBottom: 2,
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* From Date */}
            <DatePicker
              label="From Date"
              value={fromdate}
              onChange={(newValue) => setFromdate(newValue)}
              format="DD/MM/YYYY"
              maxDate={dayjs()}
              slotProps={{
                textField: {
                  readOnly: true,
                  size: "small",
                  fullWidth: true,
                },
              }}
              sx={{ maxWidth: 150 }}
            />

            {/* To Date */}
            <DatePicker
              label="To Date"
              value={todate}
              onChange={(newValue) => setTodate(newValue)}
              format="DD/MM/YYYY"
              maxDate={dayjs()}
              slotProps={{
                textField: {
                  readOnly: true,
                  size: "small",
                  fullWidth: true,
                },
              }}
              sx={{ maxWidth: 150 }}
            />
          </LocalizationProvider>
          <Button variant="contained" color="primary" onClick={handleFilter}>
            Apply Filter
          </Button>
          <Button variant="contained" color="primary" onClick={handleFetchall}>
            Overall Pancard Report
          </Button>
        </Box>
      </div>

      {loading ? (
        <Box textAlign="center" mt={2}>
          <CircularProgress />
        </Box>
      ) : Array.isArray(data) && data.length > 0 ? (
        <PanCardReportPage data={data} type={reportType} />
      ) : (
        isFilterClicked && (
          <Box textAlign="center" mt={2} fontWeight="bold" color="black">
            No Pan Card reports found
          </Box>
        )
      )}
    </>
  );
};

export default PanCardFilters;
